export default [
    {
        value: {
            value: 'pending',
            id: 1,
        },
        label: 'Pendiente'
    }, {
        value: {
            value: 'success',
            id: 2,
        },
        label: 'Confirmado',
    }, {
        value: {
            value: 'expired',
            id: 3,
        },
        label: 'Rechazado',
    }, {
        value: {
            value: 'expired',
            id: 4,
        },
        label: 'Vencido',
    }
];
